<template>

    <!-- DIALOG LANGUAGE -->
    <v-dialog v-model="show" max-width="500px" :persistent="false">

        <v-card class="pa-6" v-if="show">

            <div class="grey--text text--darken-2">{{ $store.getters.getSelectedLangString }}</div>

            <v-container class="px-2">

                <v-row dense>
                    <v-col cols="12">
                        <form @submit.prevent="save">
                            <v-text-field :loading="isLoading" required :prefix="currentLang.shortcode + ': '" autofocus v-model="label.value"></v-text-field>
                        </form>
                    </v-col>

                </v-row>
            </v-container>

            <v-card-actions class="pa-0 ma-0">
                <v-spacer></v-spacer>
                <v-btn text small :disabled="isSaving" @click="close">Abbrechen</v-btn>
                <v-btn elevation="0" color="themeColor" small light @click="save" :loading="isSaving">Speichern</v-btn>
            </v-card-actions>

        </v-card>

    </v-dialog>

</template>


<script>
export default {

    props: {
        show: {
            type: Boolean
        }
    },

    data: () => ({

        isLoading: false,
        isSaving: false,

        label: {
            id: null,
            key: null,
            value: null,
            language_id: 1
        },

        defaultLabel: {
            id: null,
            key: null,
            value: null,
            language_id: 1
        },

    }),

    created() {

    },

    mounted() {

    },

    computed: {

        languages() {
          return this.$store.getters.getLanguages;
        },

        currentLang() {
          return this.languages.find((lang) => lang.id == this.label.language_id);
        }
    },

    watch: {

        show(val) {

            if(val === true) {

                this.label.key = this.$store.getters.getSelectedLangString;
                this.fetchLabel(this.$store.getters.getSelectedLangString);

            }

        }


    },

    methods: {

        fetchLabel(labelKey) {

            this.isLoading = true;

            this.axios.get('labels/byKey?key='+labelKey).then(res => {

                let label = res.data.filter(_ => _.language_id == this.currentUser.language_id)[0];

                if(label) {
                    this.label.id = label.id;
                    this.label.value = label.value;
                }
                this.label.language_id = this.currentUser.language_id;

                this.isLoading = false;


            })

        },


        close() {

            this.$store.commit('SHOW_MODAL_LANGUAGE', false);

            this.isSaving = false;
            this.$nextTick(() => {
                this.label = Object.assign({}, this.defaultLabel);
            })

        },

        save() {

            this.isSaving = true;

            if(this.label.id == null) {

                delete this.label.id;
                this.axios.post('labels', this.label).then(res => {

                    this._refreshLabels();

                });

            } else {

                this.axios.put('labels/'+this.label.id, this.label).then(res => {

                    this._refreshLabels();

                })

            }


        },

        _refreshLabels() {

            this.$store.dispatch('fetchLabels', { language_id: this.currentUser.language_id })
                .then(() => {
                    this.$i18n.setLocaleMessage(this.currentLang.shortcode, this.$store.state.labels);
                    this.close();

                });

        },
    }

}

</script>


<style lang="scss">


</style>
